import { useTheme as useThemeStyled } from 'styled-components';

import { themeLight } from './themeConstatns';

export const useTheme = () => {
  return useThemeStyled() as typeof themeLight;
};
